import { useQuery } from '@tanstack/react-query';
import { notifKeys, notificationsApi } from '../api/notifications.api';

/** Cheap unread counters for the sidebar badge and the bell; polled every 45 s. */
export function useNotificationSummary(enabled = true) {
  return useQuery({
    queryKey: notifKeys.summary,
    queryFn: notificationsApi.summary,
    enabled,
    refetchInterval: 45_000,
    staleTime: 20_000,
    retry: false,
    meta: { silent: true },
  });
}
